module.exports = __webpack_public_path__ + "static/blog_grid_4-d94e7cf0a004f152f058ead09c65279f.jpg";